export function wasMoreThanXMinutesAgo(givenDate, minutes) {
  if (!givenDate) return false;

  const now = new Date();
  const diffInMs = now - new Date(givenDate);
  const diffInMinutes = diffInMs / (1000 * 60);

  return diffInMinutes > minutes;
}
